import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=37ca8ab2&scoped=true&"
import script from "./ItemPreview.vue?vue&type=script&lang=js&"
export * from "./ItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./ItemPreview.vue?vue&type=style&index=0&id=37ca8ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca8ab2",
  null
  
)

export default component.exports